<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import StepOne from "./StepOne.vue"
  import StepThree from "./StepThree.vue"
  import StepTwo from "./StepTwo.vue"
  export const TipoBeneficiario = {
    ESTUDANTE: 1,
    TRABALHADOR: 2,
    ESTAGIARIO: 3,
  }

  export default {
    components: {
      Breadcrumbs,
      StepOne,
      StepTwo,
      StepThree,
    },
    data: () => ({
      TipoBeneficiario,
      title: "SPL Navegantes",
      crumbs: [
        { name: "Início", path: "index" },
        { name: "SPL Navegantes", path: "spl-navegantes.index" },
        { name: "Cadastro", path: "spl-navegantes.show" },
      ],
      step: 1,
      beneficiario: {
        nmnome: "",
        dtnascimento: "",
        nmfiliacao: "",
        tpparentesco: null,
        document: "",
        cep: "",
        street: "",
        number: "",
        district: "",
        complement: "",
        municipio: {},
        filiacao: [
          {
            document: "",
            nmnome: "",
            tpparentesco: null,
            cep: "",
            street: "",
            number: "",
            district: "",
            complement: "",
            municipio: {},
          },
        ],
        contatos: {
          email: [""],
          telefone: [""],
        },
        contato_filiacao: {
          email: [""],
          telefone: [""],
        },

        numunicipio: {},
        tpbeneficiario: TipoBeneficiario.ESTUDANTE,
        imagem: null,
        instituicao: "",
      },

      beneficiarioTrabalhador: {
        idprofissao: "",
        vlsalario: 0,
        dtadmissao: "",
        nminstituicao: "",
        document: "",
      },

      beneficiarioEstudante: {
        nminstituicao: "",
        tpcurso: null,
        nuseriecurso: null,
        idcurso: null,
        document: "",
      },

      beneficiarioEstagiario: {
        dtadmissao: "",
        nminstituicao: "",
        dtencerramento: "",
        document: "",
      },
      endereco: {
        cep: "",
        street: "",
        number: "",
        district: "",
        complement: "",
        municipio: "",
      },

      contatosInstituicao: {
        email: [""],
        telefone: [""],
      },
    }),
    mounted() {
      document.title = `${this.title} - ${process.env.VUE_APP_TITLE}`
    },
    methods: {
      nextStep() {
        this.step += 1
      },
      previousStep() {
        this.step -= 1
      },
    },
  }
</script>

<template>
  <div class="w-full bg-gray-light">
    <div class="lg:max-w-5xl my-4 px-2 sm:px-6">
      <Breadcrumbs class="mb-8" :crumbs="crumbs"/>
      <StepOne
        v-if="step===1"
        :beneficiario="beneficiario"
        :TipoBeneficiario="TipoBeneficiario"
        @nextStep="nextStep()"
        @previousStep="previousStep"
      />
      <StepTwo
        v-if="step===2"
        :beneficiario="beneficiario"
        :TipoBeneficiario="TipoBeneficiario"
        :endereco="endereco"
        :contatosInstituicao="contatosInstituicao"
        :beneficiarioTrabalhador="beneficiarioTrabalhador"
        :beneficiarioEstudante="beneficiarioEstudante"
        :beneficiarioEstagiario="beneficiarioEstagiario"
        @nextStep="nextStep()"
        @previousStep="previousStep()"
      />
      <StepThree
        v-if="step===3"
        :beneficiario="beneficiario"
        :TipoBeneficiario="TipoBeneficiario"
        :endereco="endereco"
        :contatosInstituicao="contatosInstituicao"
        :beneficiarioTrabalhador="beneficiarioTrabalhador"
        :beneficiarioEstudante="beneficiarioEstudante"
        :beneficiarioEstagiario="beneficiarioEstagiario"
        @nextStep="nextStep()"
        @previousStep="previousStep()"
      />
    </div>
  </div>
</template>
